/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'application-profile';

export const applicationProfileBreadcrumbTitle = `${prefix}.applicationProfileBreadcrumbTitle`;
export const compressionFilterleBreadcrumbTitle = `${prefix}.compressionFilterleBreadcrumbTitle`;

export const ENGLISH = {
    [applicationProfileBreadcrumbTitle]: 'Application Profile',
    [compressionFilterleBreadcrumbTitle]: 'Compression Filter',
};
